import { render, staticRenderFns } from "./NotificationEmailNotVerified.vue?vue&type=template&id=18632847&lang=pug&"
import script from "./NotificationEmailNotVerified.vue?vue&type=script&lang=js&"
export * from "./NotificationEmailNotVerified.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports